export interface RagQueryResult {
  answer?: string;
  results?: Array<{ chunk?: { content?: string }; score?: number }>;
}

export interface RagQueryParams {
  query: string;
  houseId?: string;
  topK?: number;
  generateAnswer?: boolean;
}

export interface RagIngestParams {
  sourceId: string;
  title: string;
  content: string;
  type?: string;
  houseId?: string;
}

export interface SupportChatParams {
  message: string;
  houseId?: string;
  history?: Array<{ role: string; text: string }>;
  lang?: 'en' | 'es';
  role?: string;
  traceId?: string;
}

export interface SupportChatResult {
  reply: string;
  escalate?: boolean;
  confidence?: number;
  category?: string;
  priority?: string;
  intent?: string;
  actions?: Array<{ id: string; label: string; target: string }>;
  handoffOffer?: boolean;
  followUp?: string;
  diagnosticSteps?: string[];
}

export async function ragQuery(params: RagQueryParams): Promise<RagQueryResult> {
  const { callFunction } = await import('../firebase/FunctionsService');
  return callFunction('ragQuery', params) as Promise<RagQueryResult>;
}

export async function ragIngest(params: RagIngestParams): Promise<unknown> {
  const { callFunction } = await import('../firebase/FunctionsService');
  return callFunction('ragIngest', params);
}

export async function supportChat(params: SupportChatParams): Promise<SupportChatResult> {
  const { callFunction } = await import('../firebase/FunctionsService');
  return callFunction('supportChat', params) as Promise<SupportChatResult>;
}
